export enum DialogIds {
  AboutDialog = 'AboutDialog',
  AddTeamModelDialog = 'AddTeamModelDialog',
  AssignUserRoleDialog = 'AssignUserRoleDialog',
  BookmarkAccessDialog = 'BookmarkAccessDialog',
  ClipboardDialog = 'ClipboardDialog',
  ConfirmDialog = 'ConfirmDialog',
  ContactDialog = 'ContactDialog',
  GroupRestrictionDialog = 'GroupRestrictionDialog',
  ImageDialog = 'ImageDialog',
  ImportDialog = 'ImportDialog',
  JoinDomainDialog = 'JoinDomainDialog',
  LimitDialog = 'LimitDialog',
  ManageDialog = 'ManageDialog',
  PremiumContentDialog = 'PremiumContentDialog',
  PricingDialog = 'PricingDialog',
  ProfileDialog = 'ProfileDialog',
  QuizSettingsDialog = 'QuizSettingsDialog',
  RemoveUserDialog = 'RemoveUserDialog',
  SaveAsBookmarkDialog = 'SaveAsBookmarkDialog',
  SaveBookmarkDialog = 'SaveBookmarkDialog',
  SaveModuleDialog = 'SaveModuleDialog',
  TransferUserContentDialog = 'TransferUserContentDialog',
  WelcomeTourDialog = 'WelcomeTourDialog',
  TrialExpiredDialog = 'TrialExpiredDialog',
  PremiumAccessDialog = 'PremiumAccessDialog'
}
